<!-- eslint-disable @angular-eslint/template/no-call-expression -->
@for (doc of docs; track $index) {
  <a
    [href]="pdfPrefix + onboardingId() + '/' + doc + '/' + ('child-onboarding.docs.' + doc + '.file' | transloco)"
    target="_blank"
    rel="noopener noreferrer"
    class="zero-text link d-block mb-3"
  >
    {{ 'child-onboarding.docs.' + doc + '.label' | transloco }}
  </a>
}
